"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOptionListBy = exports.createLoginItemDependsOnSegment = exports.transformUserName = void 0;
const logingUtils_1 = require("../logingUtils");
const utils_1 = require("../utils");
const constants_1 = require("../constants");
const transformUserName = (userName) => {
    let result = userName;
    if (result) {
        try {
            const temp = result.split(' ');
            result = '';
            for (let i = 0; i < temp.length; i += 1) {
                if (temp[i]) {
                    result += `${temp[i][0].toUpperCase()}${temp[i]
                        .slice(1)
                        .toLowerCase()} `;
                }
            }
        }
        catch (e) {
            return userName;
        }
    }
    return result;
};
exports.transformUserName = transformUserName;
const createLoginItemDependsOnSegment = (segment, isGestor, userType, fullName, context, userSegment) => {
    const handleLogoutGestor = () => {
        // handleModal('logout-gestor');
    };
    // si no estoy logado como cliente ni como gestor, no hay bolita
    if (!userType && !isGestor) {
        return null;
    }
    const tempItem = Object.assign({}, constants_1.LOGIN_ITEM);
    // bola de login cliente comun
    if (!isGestor && userType) {
        if (segment === constants_1.PARTICULARES && userType) {
            const hello = (0, utils_1.sayHello)();
            tempItem.label = `${hello}${fullName ? ` ${(0, exports.transformUserName)(fullName)}` : ''}`;
        }
        if (segment === constants_1.EMPRESAS && userType) {
            tempItem.label = (0, utils_1.sayHello)();
        }
        const realUserSegment = (0, utils_1.decideUserSegment)(userSegment, segment);
        tempItem.color = segment === constants_1.PARTICULARES ? 'grey6' : 'white';
        if ((0, utils_1.checkIFPaut)(userSegment)) {
            tempItem.onClick = () => (0, logingUtils_1.logoutFromMovistar)({
                back2Home: false,
                userType: context.userType,
                pautLogout: true,
            });
        }
        else {
            tempItem.onClick = () => (0, logingUtils_1.logoutFromMovistar)({
                back2Home: true,
                userType: context.userType,
                pautLogout: false,
            });
        }
    }
    // bolita login si es gestor, cambio la funcionalidad
    if (isGestor) {
        tempItem.label = '';
        // accedo a context para ver si tiene datos del gestor
        if (context && context.managerInfo) {
            const { name, roleCode, shopName } = context.managerInfo;
            tempItem.label = `${shopName} : ${roleCode} - ${name}`;
        }
        tempItem.color = 'grey6';
        // metemos la logica del modal de GEstor
        tempItem.onClick = handleLogoutGestor;
    }
    return tempItem;
};
exports.createLoginItemDependsOnSegment = createLoginItemDependsOnSegment;
const createOptionListBy = (segment, gestorOpts, userType, fullName, userSegment) => {
    const { isGestor, context } = gestorOpts;
    const res = [];
    const loginItem = (0, exports.createLoginItemDependsOnSegment)(segment, isGestor, userType, fullName, context, userSegment);
    // LOGADO
    if (loginItem) {
        res.push(loginItem);
    }
    if (!isGestor && segment === constants_1.PARTICULARES) {
        res.push(constants_1.SHOP_ITEM);
    }
    return res;
};
exports.createOptionListBy = createOptionListBy;
//# sourceMappingURL=utils.js.map